import { render, staticRenderFns } from "./CRUDListing.vue?vue&type=template&id=05d3df48&"
import script from "./CRUDListing.vue?vue&type=script&lang=js&"
export * from "./CRUDListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports